import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgFilterComponent, CustomFilterParams } from '../ag-filter.component';
import { IAfterGuiAttachedParams, IDoesFilterPassParams } from 'ag-grid-community';
import { takeUntil } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { LetDirective } from '@ngrx/component';

@Component({
    selector: 'app-ag-single-select-filter',
    templateUrl: './ag-single-select-filter.component.html',
    styleUrls: ['./ag-single-select-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [LetDirective, NgClass, MatIcon]
})
export class AgSingleSelectFilterComponent extends AgFilterComponent {

  filterOptions: { name, value }[];
  private hidePopup: () => void;

  protected filterState: BehaviorSubject<string> = new BehaviorSubject<string>('');
  protected filterState$ = this.filterState.asObservable();
  constructor() {
    super();
  }

  override agInit(params: CustomFilterParams) {
    super.agInit(params);
    // init filter options
    this.filterOptions = [{name: '-', value: ''}, ...(params.filterOptions) as { name, value }[]];
    // update filter on formControl change
    this.filterState$.pipe(takeUntil(this.componentDestroyed))
        .subscribe(() => this.updateFilter());
    // set FormControl
    this.filterState.next(this.filterOptions[0].value);
  }

  override get filterValue(): string {
    return this.filterState?.value;
  }

  override setModel(model: string) {
    this.filterState.next(model);
    this.updateFilter();
  }

  override doesFilterPass(params: IDoesFilterPassParams): boolean {
    if (!this.isFilterActive()) {
      return true; // early return, filter is inactive
    }

    // get the value for this filter's column for the provided row data
    // https://www.ag-grid.com/angular-data-grid/component-floating-filter/
    // see Custom Filter And Custom Floating Filter for reference

    const { node } = params;
    const value = this.params.getValue(node)


    // check for callback in filter params, if not present, define default
    const filterCb: (filterOptionValue: any, cellValue: any) => boolean = this.params?.filterCb ?
        this.params.filterCb :
        (filterOptionValue: string, cellValue: string) =>
            filterOptionValue.trim().toLowerCase() === cellValue.trim().toLowerCase();

    // check for some falsy values (we want 0 and boolean false to pass to support number and
    // boolean filters)
    return value !== null &&
        value !== undefined &&
        value !== '' &&
        // run the filter
        filterCb(this.filterValue, value);
  }

  handleReset() {
    this.filterState.next(this.filterOptions[0]?.value);
    this.updateFilter();
  }

  afterGuiAttached(params: IAfterGuiAttachedParams) {
    this.hidePopup = params.hidePopup;
  }


  /**
   * Set filter state, apply filter and hide the popup
   * @param value
   */
  userSelectFilterValue(value: string) {
    this.filterState.next(value);
    this.hidePopup();
  }

}
